export enum AnswerOption {
  computer = 'computer',
  phone = 'phone',
}

export enum MicrophonePermissionState {
  granted = 'granted',
  prompt = 'prompt',
  denied = 'denied',
}

/**
 * Twilio falls back to the default device when no device is selected.
 */
export const BROWSER_DEFAULT_AUDIO_DEVICE_ID = 'default';
